// src/components/store/CustomerTestimonials.tsx
"use client";

import TestimonialSectionRenderer from "./sections/testimonials";

export default function CustomerTestimonials(props: any) {
  return <TestimonialSectionRenderer {...props} />;
}
export * from "./sections/testimonials";
